'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = jointLoginRoot;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _WatcherCreatorHelper = require('./WatcherCreatorHelper');

var _WatcherCreatorHelper2 = _interopRequireDefault(_WatcherCreatorHelper);

var _JointLoginActions = require('../actions/JointLoginActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(facebookLoginThroughNativeWrapper),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(facebookLogin),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(jointLoginRoot);

function detectFacebookAvailability(_ref) {
    var FB = _ref.FB;

    return !!FB && !FB.__noSuchMethod__;
}

var passwordLoginWorker = function passwordLoginWorker(_ref2) {
    var authentication = _ref2.authentication;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var username, password;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            username = payload.username, password = payload.password;
                            _context.next = 3;
                            return (0, _effects.call)(function () {
                                return authentication('/com.openrest/access_token', 'post', { username: username, password: password });
                            });

                        case 3:
                            return _context.abrupt('return', _context.sent);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })
    );
};

function facebookLoginThroughNativeWrapper(_ref3) {
    var softLogin = _ref3.softLogin,
        NativeMessaging = _ref3.NativeMessaging;
    return _regenerator2.default.wrap(function facebookLoginThroughNativeWrapper$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (softLogin) {
                        NativeMessaging.dispatchEvent('softLoginWithFacebook');
                    } else {
                        NativeMessaging.dispatchEvent('hardLoginWithFacebook');
                    }

                    _context2.next = 3;
                    return (0, _effects.cps)(function (cb) {
                        var listener = function listener(payload) {
                            NativeMessaging.removeEventListener('gotFBAccessToken', listener);

                            cb(null, { accessToken: payload.accessToken });
                        };
                        NativeMessaging.addEventListener('gotFBAccessToken', listener);
                    });

                case 3:
                    return _context2.abrupt('return', _context2.sent);

                case 4:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this);
}

function facebookLogin(_ref4) {
    var authentication = _ref4.authentication,
        FB = _ref4.FB,
        isMobileNative = _ref4.isMobileNative,
        NativeMessaging = _ref4.NativeMessaging,
        softLogin = _ref4.softLogin;
    var authResponse, origAccessToken, rc;
    return _regenerator2.default.wrap(function facebookLogin$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (!(false && !detectFacebookAvailability({ FB: FB }))) {
                        _context3.next = 4;
                        break;
                    }

                    _context3.next = 3;
                    return (0, _effects.put)(_JointLoginActions.actions.setFacebookAvailability(false));

                case 3:
                    throw new Error('FB not available');

                case 4:
                    authResponse = void 0, origAccessToken = void 0;

                    if (!isMobileNative) {
                        _context3.next = 12;
                        break;
                    }

                    _context3.next = 8;
                    return facebookLoginThroughNativeWrapper({ softLogin: softLogin, NativeMessaging: NativeMessaging });

                case 8:
                    authResponse = _context3.sent;

                    origAccessToken = authResponse.accessToken;
                    _context3.next = 15;
                    break;

                case 12:
                    _context3.next = 14;
                    return (0, _effects.cps)(function (cb) {
                        var fbLoginMethod = softLogin ? FB.getLoginStatus : FB.login;

                        fbLoginMethod(function (res) {
                            cb(null, res.authResponse);
                        }, function (err) {
                            cb(err);
                        });
                    });

                case 14:
                    authResponse = _context3.sent;

                case 15:
                    if (!authResponse) {
                        _context3.next = 23;
                        break;
                    }

                    _context3.next = 18;
                    return (0, _effects.call)(function () {
                        return authentication('/com.facebook/access_token', 'post', { accessToken: authResponse.accessToken });
                    });

                case 18:
                    rc = _context3.sent;


                    if (isMobileNative) {
                        rc.origAccessToken = origAccessToken;
                    }

                    return _context3.abrupt('return', rc);

                case 23:
                    throw new Error('No Facebook permissions');

                case 24:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}

var _ref5 = function () {
    var _marked3 = /*#__PURE__*/_regenerator2.default.mark(initGoogleLogin),
        _marked4 = /*#__PURE__*/_regenerator2.default.mark(googleLogin);

    var auth2 = void 0;

    function initGoogleLogin(_ref6) {
        var gapi = _ref6.gapi,
            authentication = _ref6.authentication;
        var userChange, authResult, googleProfile, userData;
        return _regenerator2.default.wrap(function initGoogleLogin$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        userChange = (0, _reduxSaga.eventChannel)(function (emit) {
                            gapi.load('auth2', function () {
                                var clientId = '582150142008-tfp6p3jc9ipia8hfucgqfeos8j6ogq4h.apps.googleusercontent.com';

                                auth2 = gapi.auth2.init({
                                    client_id: clientId,
                                    scope: 'profile'
                                });

                                auth2.currentUser.listen(function (val) {
                                    if (val && !(0, _isEmpty2.default)(val.getAuthResponse())) {
                                        var idToken = val.getAuthResponse().id_token;
                                        authentication('/com.google/access_token', 'post', { idToken: idToken, clientId: clientId }).then(emit);
                                    } else {
                                        // userLoggedOut;
                                    }
                                });

                                if (auth2.isSignedIn.get() === true) {
                                    auth2.signIn();
                                }
                            });

                            return _noop2.default;
                        });

                    case 1:
                        if (!true) {
                            _context4.next = 11;
                            break;
                        }

                        _context4.next = 4;
                        return (0, _effects.take)(userChange);

                    case 4:
                        authResult = _context4.sent;
                        googleProfile = auth2.currentUser.get().getBasicProfile();
                        userData = {
                            pictureUrl: googleProfile.getImageUrl(),
                            name: googleProfile.getName(),
                            firstName: googleProfile.getGivenName(),
                            lastName: googleProfile.getFamilyName()
                        };
                        _context4.next = 9;
                        return (0, _effects.put)(_JointLoginActions.actions.loginSuccess((0, _extends3.default)({}, authResult, { userData: userData })));

                    case 9:
                        _context4.next = 1;
                        break;

                    case 11:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _marked3, this);
    }

    function googleLogin(_ref7) {
        var gapi = _ref7.gapi;
        return _regenerator2.default.wrap(function googleLogin$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        gapi.auth2.getAuthInstance().signIn();

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _marked4, this);
    }

    return {
        initGoogleLogin: initGoogleLogin,
        googleLogin: googleLogin
    };
}(),
    initGoogleLogin = _ref5.initGoogleLogin,
    googleLogin = _ref5.googleLogin;

var facebookLoginWorker = function facebookLoginWorker(params) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return facebookLogin((0, _extends3.default)({}, params, { softLogin: true }));

                        case 2:
                            return _context6.abrupt('return', _context6.sent);

                        case 3:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee2, this);
        })
    );
};

var initGoogleLoginWorker = function initGoogleLoginWorker(params) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return initGoogleLogin((0, _extends3.default)({}, params));

                        case 2:
                            return _context7.abrupt('return', _context7.sent);

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee3, this);
        })
    );
};

var googleLoginWorker = function googleLoginWorker(params) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return googleLogin((0, _extends3.default)({}, params));

                        case 2:
                            return _context8.abrupt('return', _context8.sent);

                        case 3:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee4, this);
        })
    );
};

var facebookHardLoginWorker = function facebookHardLoginWorker(params) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return facebookLogin((0, _extends3.default)({}, params, { softLogin: false }));

                        case 2:
                            return _context9.abrupt('return', _context9.sent);

                        case 3:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee5, this);
        })
    );
};

var facebookLogoutWorker = function facebookLogoutWorker(_ref8) {
    var FB = _ref8.FB;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            var response;
            return _regenerator2.default.wrap(function _callee6$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return (0, _effects.cps)(function (cb) {
                                FB.logout(function (res) {
                                    cb(null, res);
                                }, function (err) {
                                    cb(err);
                                });
                            });

                        case 2:
                            response = _context10.sent;

                            if (!response) {
                                _context10.next = 7;
                                break;
                            }

                            return _context10.abrupt('return');

                        case 7:
                            throw new Error('Could not logout from Facebook');

                        case 8:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee6, this);
        })
    );
};

var wixLoginWorker = function wixLoginWorker(_ref9) {
    var authentication = _ref9.authentication;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var instance;
            return _regenerator2.default.wrap(function _callee7$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            instance = payload.instance;
                            _context11.prev = 1;
                            _context11.next = 4;
                            return (0, _effects.call)(function () {
                                return authentication('/com.wix/access_token', 'post', { instance: instance });
                            });

                        case 4:
                            return _context11.abrupt('return', _context11.sent);

                        case 7:
                            _context11.prev = 7;
                            _context11.t0 = _context11['catch'](1);
                            throw new Error('No Wix apps found');

                        case 10:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee7, this, [[1, 7]]);
        })
    );
};

/********* WATCHERS ***********/

var watchPasswordLoginRequest = function watchPasswordLoginRequest(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.LOGIN_WITH_PASSWORD,
            worker: passwordLoginWorker(sagaParams),
            request: _JointLoginActions.actions.loginRequest,
            success: _JointLoginActions.actions.loginSuccess,
            failure: _JointLoginActions.actions.loginFailure
        });
    };
};

var watchFacebookLoginRequest = function watchFacebookLoginRequest(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.LOGIN_WITH_FACEBOOK,
            worker: facebookLoginWorker(sagaParams),
            request: _JointLoginActions.actions.loginRequest,
            success: _JointLoginActions.actions.loginSuccess,
            failure: _JointLoginActions.actions.loginFailure
        });
    };
};

var watchGoogleLoginRequest = function watchGoogleLoginRequest(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.LOGIN_WITH_GOOGLE,
            worker: googleLoginWorker(sagaParams),
            request: _JointLoginActions.actions.loginRequest
        });
    };
};

var watchInitGoogleLogin = function watchInitGoogleLogin(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.INIT_GOOGLE_LOGIN,
            worker: initGoogleLoginWorker(sagaParams)
        });
    };
};

var watchFacebookHardLoginRequest = function watchFacebookHardLoginRequest(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.HARD_LOGIN_WITH_FACEBOOK,
            worker: facebookHardLoginWorker(sagaParams),
            request: _JointLoginActions.actions.loginRequest,
            success: _JointLoginActions.actions.hardLoginSuccess,
            failure: _JointLoginActions.actions.hardLoginFailure
        });
    };
};

var watchWixLoginRequest = function watchWixLoginRequest(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.LOGIN_WITH_WIX,
            worker: wixLoginWorker(sagaParams),
            request: _JointLoginActions.actions.loginRequest,
            success: _JointLoginActions.actions.loginSuccess,
            failure: _JointLoginActions.actions.loginFailure
        });
    };
};

var watchFacebookLogout = function watchFacebookLogout(sagaParams) {
    return function () {
        return (0, _WatcherCreatorHelper2.default)({
            listenTo: _JointLoginActions.types.LOGOUT_FROM_FACEBOOK,
            worker: facebookLogoutWorker(sagaParams),
            success: _JointLoginActions.actions.facebookLogoutSuccess,
            failure: _JointLoginActions.actions.facebookLogoutFailure
        });
    };
};

function jointLoginRoot(sagaParams) {
    return _regenerator2.default.wrap(function jointLoginRoot$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(watchPasswordLoginRequest(sagaParams)), (0, _effects.fork)(watchFacebookLoginRequest(sagaParams)), (0, _effects.fork)(watchFacebookHardLoginRequest(sagaParams)), (0, _effects.fork)(watchWixLoginRequest(sagaParams)), (0, _effects.fork)(watchFacebookLogout(sagaParams)), (0, _effects.fork)(watchGoogleLoginRequest(sagaParams)), (0, _effects.fork)(watchInitGoogleLogin(sagaParams)), (0, _effects.fork)(function () {
                        return (0, _WatcherCreatorHelper2.default)({
                            listenTo: _JointLoginActions.types.SET_ACCESS_TOKEN,
                            worker: /*#__PURE__*/_regenerator2.default.mark(function worker(payload) {
                                var authResponse;
                                return _regenerator2.default.wrap(function worker$(_context12) {
                                    while (1) {
                                        switch (_context12.prev = _context12.next) {
                                            case 0:
                                                if (!payload.accessToken) {
                                                    _context12.next = 15;
                                                    break;
                                                }

                                                _context12.prev = 1;
                                                _context12.next = 4;
                                                return (0, _effects.call)(function () {
                                                    return sagaParams.authentication('/me', 'get', null, payload.accessToken);
                                                });

                                            case 4:
                                                authResponse = _context12.sent;
                                                _context12.next = 7;
                                                return (0, _effects.put)(_JointLoginActions.actions.loginSuccess({
                                                    user: authResponse,
                                                    accessToken: payload.accessToken
                                                }));

                                            case 7:
                                                _context12.next = 9;
                                                return (0, _effects.put)(_JointLoginActions.actions.setUsingForceAccessToken(true));

                                            case 9:
                                                _context12.next = 15;
                                                break;

                                            case 11:
                                                _context12.prev = 11;
                                                _context12.t0 = _context12['catch'](1);
                                                _context12.next = 15;
                                                return (0, _effects.put)(_JointLoginActions.actions.setFastCheckoutEnabled(false));

                                            case 15:
                                            case 'end':
                                                return _context12.stop();
                                        }
                                    }
                                }, worker, this, [[1, 11]]);
                            })
                        });
                    })]);

                case 2:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked5, this);
}